import CONSTANTS from '../vars/CONSTANTS';

export default async function fetchRemoteWishlist() {
  try {
    if (!CONSTANTS.CUSTOMER_LOGGED_IN) return [];
    const res = await fetch(CONSTANTS.ALL_WISHLIST_URL);
    const data = await res.json();
    const products = data?.metafield?.value || [];
    return products;
  } catch (error) {
    console.error('[Wishlist] Failed to fetch wishlist', error);
    return [];
  }
}
